import Vuex from 'vuex';
/**Store login */
import Store_actions_login from "./store.login/store.actions.login.js";
/**Store group */
import Store_actions_group from "./store.group/store.actions.group.js";
/**Store subgroup */
import Store_actions_subgroup from "./store.subgroup/store.actions.subgroup.js";
/**Store volumen */
import Store_actions_volume from "./store.volume/store.actions.volume.js";
/**Store users */
import Store_actions_user from "./store.user/store.actions.user.js";
/**Store ui */
import Store_actions_ui from "./store.ui/store.actions.ui.js";
import Store_state_ui from "./store.ui/store.state.ui.js";
import Store_mutations_ui from "./store.ui/store.mutations.ui.js";
import Store_getters_ui from "./store.ui/store.gettets.ui";
const store = new Vuex.Store({
    modules: {
        login: {
            actions: Store_actions_login
        },
        group: {
            actions: Store_actions_group
        },
        subgroup: {
            actions: Store_actions_subgroup
        },
        user:{
            actions:Store_actions_user
        },
        volume:{
            actions:Store_actions_volume
        },
        ui: {
            state: Store_state_ui,
            getters: Store_getters_ui,
            mutations: Store_mutations_ui,
            actions:Store_actions_ui
        }
    }
});
export default store;